import { convincely } from '@convincely/utils/lib/services/convincely.js';
if (!convincely.onPopStates) {
    convincely.onPopStates = [];
    convincely.onPopStatesOther = [];
    window.addEventListener('popstate', (e) => {
        const state = e.state || {};
        if (state.funnel) {
            if (!state.bubbles) {
                e.stopImmediatePropagation();
            }
            for (const fn of convincely.onPopStates) {
                fn(e);
            }
        }
        else {
            for (const fn of convincely.onPopStatesOther) {
                fn(e);
            }
        }
    });
}
//# sourceMappingURL=popstate.js.map